import React, { useEffect, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Chip,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import { Icon } from "@iconify/react/dist/iconify.js";
import {
  getWorkFromHomeTasks,
  updateWFHTaskStatus,
} from "../../../../redux/features/leaveSlice";
import GlobalDialog from "../../../../components/mui/Dialogue/GlobalDialog";
import Loader3D from "../../../../components/Loader/Loader3D";
import UpdatetaskStatus from "./UpdateTaskStatus";

const WFHTasks = ({ rowData }) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { loading, wfhTasks } = useSelector((state) => state.leave);

  useEffect(() => {
    if (open) {
      dispatch(
        getWorkFromHomeTasks({
          leaveAppId: rowData?.leaveId,
          isHead: false,
        })
      );
    }
  }, [open, rowData, dispatch]);

  return (
    <GlobalDialog
      title={"WFH Tasks"}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"md"}
      closeButton={true}
      popupButton={
        <Button
          size="small"
          variant="outlined"
          color="primary"
          startIcon={<Icon icon={"mdi:eye"} width={18} height={18} />}
          onClick={() => setOpen(true)}
        >
          View
        </Button>
      }
      content={
        <>
          {loading && (
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                bgcolor: "rgba(255,255,255,0.6)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 10,
              }}
            >
              <Loader3D />
            </Box>
          )}
          <Box>
            {wfhTasks?.length === 0 && (
              <Alert variant="outlined" severity="info" sx={{ mt: 1, mb: 1 }}>
                No tasks added
              </Alert>
            )}
            <Stack direction="column" spacing={2}>
              {wfhTasks?.map((task) => (
                <Stack
                  key={task.wfh_task_id}
                  direction="row"
                  spacing={1}
                  alignItems="center"
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                      px: 2,
                      py: 2,
                      borderRadius: 2,
                      width: "100%",
                      boxShadow: " rgba(0, 0, 0, 0.24) 0px 3px 8px ",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        justifyContent: "center",
                      }}
                    >
                      <Typography color={"black"} variant="subtitle1" mb={1}>
                        {task.task_name}
                      </Typography>
                      <Typography color={"gray"} variant="caption">
                        Created By {task.created_by_name}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end",
                        justifyContent: "center",
                        gap: 1,
                      }}
                    >
                      <Chip
                        variant="outlined"
                        label={task.status_name}
                        color={
                          task.status_name === "Completed"
                            ? "success"
                            : task.status_name === "In Progress"
                            ? "warning"
                            : "error"
                        }
                      />
                      <UpdatetaskStatus
                        TaskID={task.wfh_task_id}
                        status={task.status}
                        leaveAppID={rowData?.leaveId}
                        disabled={rowData?.wfh_task_approved !== 1}
                      />
                    </Box>
                  </Box>
                </Stack>
              ))}
            </Stack>

            <Box sx={{ display: "flex", justifyContent: "flex-end", pt: 3 }}>
              <Button
                size="small"
                variant="outlined"
                color="secondary"
                startIcon={<Icon icon={"mdi:close"} width={18} height={18} />}
                onClick={() => setOpen(false)}
              >
                Close
              </Button>
            </Box>
          </Box>
        </>
      }
    />
  );
};

export default WFHTasks;
